import { render, staticRenderFns } from "./OpenLink.vue?vue&type=template&id=07754587&"
import script from "./OpenLink.vue?vue&type=script&lang=js&"
export * from "./OpenLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports